import getValidationErrors from "@app/util/errorHandling/getValidationErrors";

export const SAVED_ADDRESS_LIMIT_CODE = "v1211";
export const RESERVED_SLOT_TAKEN_CODE = "v1212";

export type SavedAddressErrorCode =
  | typeof RESERVED_SLOT_TAKEN_CODE
  | typeof SAVED_ADDRESS_LIMIT_CODE;

export const hasSavedAddressErrorCode = (error: unknown, code: SavedAddressErrorCode) =>
  getValidationErrors(error).some((validationError) => validationError.code === code);
